import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const FullCatalogPage = lazy(() => import('~/features/content-enrichment/pages/full-catalog-page'));

/** Step 3 — Full Catalog Generation page for the Meta Ads enrichment funnel. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/full',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <FullCatalogPage />
    </Suspense>
  ),
});
